import { createContext, useContext } from 'react'

interface DrawerContextType {
  drawerOpen: boolean
  handlerDrawerOpen: () => void
  isDrawerExpanded: boolean
  isMiniDrawer: boolean
}

export const DrawerContext = createContext<DrawerContextType>({
  drawerOpen: true,
  handlerDrawerOpen: () => {},
  isDrawerExpanded: true,
  isMiniDrawer: false,
})

export function useDrawer() {
  return useContext(DrawerContext)
}
